let basicSwiperRuntimePromise = null;
let fullSwiperRuntimePromise = null;

const getInstalledSwiper = () => window.Swiper?.default || window.Swiper || null;
const hasProfile = (profile) => Boolean(getInstalledSwiper()?.__bclProfiles?.has(profile));

const loadRuntime = (profile, importRuntime) => {
  if (hasProfile(profile)) {
    return Promise.resolve(getInstalledSwiper());
  }

  return importRuntime()
    .then((module) => module.default || getInstalledSwiper())
    .catch((error) => {
      if (profile === "full") {
        fullSwiperRuntimePromise = null;
      } else {
        basicSwiperRuntimePromise = null;
      }
      throw error;
    });
};

export const ensureBasicSwiper = function () {
  if (hasProfile("basic")) {
    return Promise.resolve(getInstalledSwiper());
  }

  if (!basicSwiperRuntimePromise) {
    basicSwiperRuntimePromise = loadRuntime("basic", () => import(/* webpackChunkName: "bcl-swiper-basic" */ "./swiper-basic-bundle.js"));
  }

  return basicSwiperRuntimePromise.then((SwiperRuntime) => {
    if (!hasProfile("basic")) {
      window.Swiper = SwiperRuntime;
    }
    return SwiperRuntime;
  });
};

export const ensureSwiper = function () {
  if (hasProfile("full")) {
    return Promise.resolve(getInstalledSwiper());
  }

  if (!fullSwiperRuntimePromise) {
    fullSwiperRuntimePromise = loadRuntime("full", () => import(/* webpackChunkName: "bcl-swiper-runtime" */ "./swiper-bundle.js"));
  }

  return fullSwiperRuntimePromise.then((SwiperRuntime) => {
    if (!hasProfile("full")) {
      window.Swiper = SwiperRuntime;
    }
    return SwiperRuntime;
  });
};
